import { Directive } from '@angular/core';
/* eslint-disable */

/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
@Directive({
    selector: 'ihd-dialog-actions',
    host: {
        class: 'c-dialog__actions',
    },
})
export class DialogActionsComponent {}
